module.exports = __webpack_public_path__ + "media/bootstrap-icons/symmetry-horizontal-1d62a3d1.svg";